{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-25T10:53:25.500Z","source":"place-details"}